import { api } from "~/api";
import { MsgBox } from "~/components/MsgBox";
import { defineComponent, ref } from "vue";
import { Log } from "~/extensions/utils";
import { useRouter } from "vue-router";
import { HanyoKb, InformationDetailBeforeRouteKbn, ReadId, Weightid } from "~/extensions/utils/DefineTypes";
import { TopInformationViewModel } from "../Models/TopInfomationViewModel";
import dayjs from "dayjs";
import MypageBadge from "~/components/MypageBadge.vue";
import { commonStore } from "~/store/CommonStore";
import { CookieHelper } from "~/extensions/utils/CookieHelper";
const log = Log.create("TopInfomation");
export default defineComponent({
    name: "TopInformation",
    components: {
        MypageBadge
    },
    async setup() {
        const router = useRouter();
        const list = ref(new TopInformationViewModel());
        const weightKbn = HanyoKb.InformationWeight;
        const weightid = Weightid.weight;
        const noDataLabel = commonStore.messages.PI0011;
        const readKbn = HanyoKb.InformationRead;
        const readId = ReadId.notRead;
        //ボタン押下時の処理
        const onClick = () => {
            router.push({ name: "information-list" });
        };
        //行押下
        const onRowClick = (informationNo) => {
            CookieHelper.set("informationDetailBeforeRoute", InformationDetailBeforeRouteKbn.TopPage.toString());
            router.push({ name: "information-detail", query: { informationNo: informationNo } });
        };
        try {
            let result = await api.top.findTopInfomation();
            list.value = new TopInformationViewModel(result);
        }
        catch (ex) {
            log.error("setup", ex);
            await MsgBox.error(ex.data.errorMessage);
        }
        //未回答お知らせ一覧のタイトル生成
        let nonresponseCount = "未回答のお知らせが" + list.value.nonresponseInformation.length + "件あります";
        let today = dayjs().startOf("day");
        return {
            list,
            weightKbn,
            weightid,
            onRowClick,
            onClick,
            nonresponseCount,
            today,
            noDataLabel,
            readKbn,
            readId
        };
    }
});
